import { createFileRoute } from "@tanstack/react-router";
import { formatCurrency, formatDate, formatDateRange } from "shared";
import givefrontLogo from "../../../assets/brand/givefrontlogofull.png";

export const Route = createFileRoute("/_authed/_org/test")({
  component: RouteComponent,
});

function RouteComponent() {
  const startDate = new Date("2024-01-01");
  const endDate = new Date("2024-01-31");
  const budgetGroup = {
    name: "Salamander Grant",
    subBudgets: [
      {
        balanceCents: 45000,
        name: "Office Supplies",
        targetCents: 100000,
      },
    ],
  };
  const transactions = [
    {
      amountCents: 5000,
      date: new Date("2024-01-05"),
      description: "AMZN XX4242 Purchase",
      postedDate: new Date("2024-01-06"),
      subBudget: "Office Supplies",
      type: "Charge",
    },
    {
      amountCents: 20000,
      date: new Date("2024-01-10"),
      description: "PXY*Subscription",
      postedDate: new Date("2024-01-11"),
      subBudget: "Software",
      type: "Charge",
    },
  ];

  return (
    <div className="flex flex-col gap-6 px-8 py-12">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <h1 className="font-semibold text-4xl text-neutral-900">
            {budgetGroup.name}
          </h1>
          <span className="mt-1 font-medium text-neutral-600">
            {formatDateRange(startDate, endDate)}
          </span>
        </div>

        <img src={givefrontLogo} className="h-8" alt="" />
      </div>

      <table className="mt-6">
        <thead>
          <tr className="border-slate-200 text-left text-slate-500 text-xs [&>th]:border [&>th]:bg-slate-100 [&>th]:px-3 [&>th]:py-2 [&>th]:font-medium">
            <th>Budget Category</th>
            <th>Total Budget</th>
            <th>Current Period Spend</th>
            <th>Budget Remaining</th>
          </tr>
        </thead>
        <tbody>
          {budgetGroup.subBudgets.map((subBudget, index) => (
            <tr
              key={index}
              className="text-sm [&>td]:border-x [&>td]:border-b [&>td]:px-3 [&>td]:py-2"
            >
              <td>{subBudget.name}</td>
              <td>{formatCurrency(subBudget.targetCents)}</td>
              <td>
                {formatCurrency(
                  transactions.reduce((acc, cur) => acc + cur.amountCents, 0),
                )}
              </td>
              <td>
                {formatCurrency(subBudget.targetCents - subBudget.balanceCents)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-6 flex items-center gap-4">
        <div className="h-px grow bg-neutral-400" />
        <h3 className="text-center font-semibold text-neutral-800 text-xl">
          Current Period Spend
        </h3>
        <div className="h-px grow bg-neutral-400" />
      </div>
      <table>
        <thead>
          <tr className="border-slate-200 text-left text-slate-500 text-xs [&>th]:border [&>th]:bg-slate-100 [&>th]:px-3 [&>th]:py-2 [&>th]:font-medium">
            <th>Description</th>
            <th>Date</th>
            <th>Type</th>
            <th>Budget</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx, index) => (
            <tr
              key={index}
              className="text-sm [&>td]:border-x [&>td]:border-b [&>td]:px-3 [&>td]:py-2"
            >
              <td>{tx.description}</td>
              <td>{formatDate(tx.postedDate)}</td>
              <td>{tx.type}</td>
              <td>{tx.subBudget}</td>
              <td>{formatCurrency(tx.amountCents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
